module.exports = __webpack_public_path__ + "static/img/303.6197c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/303.png
// module id = 512
// module chunks = 3